import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 *  Component to display a warning message in the monthly report
 */
@Component({
  selector: 'caixa-webcomponent-monthly-report-warning',
  standalone: true,
  templateUrl: './monthly-report-warning.component.html',
  styleUrl: './monthly-report-warning.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MonthlyReportWarningComponent {}
